import dxDataGrid from "devextreme/ui/data_grid";
import { IReportOneUIComponent } from "../models/ReportTypes";
export default class ExtractorDataGridOptions {
    public static getFilterText = async (gridInstance: dxDataGrid) => {
        //                    https://supportcenter.devexpress.com/ticket/details/t827587/datagrid-how-to-get-parsed-text-from-the-filter-builder-filter-panel
        //    this.gridFilterValue = this.filter;
        //    const gridInstance = this.$refs[this.dataGridRefName].instance;
        let filterText = "";
        let filterPanelView;
        let filterValue;
        let customOperations;
        try {
            filterPanelView = gridInstance["getView"]('filterPanelView');
            filterValue = filterPanelView.option('filterValue');
            customOperations = gridInstance["getController"]("filterSync").getCustomFilterOperations();
        }
        catch (e) {
            console.error(e);
            return filterText;
        }
        if (filterValue && filterPanelView && customOperations) {
            filterText = await filterPanelView.getFilterText(filterValue, customOperations);
        }
        return filterText;
    }
    public static getSearchText = (gridInstance: dxDataGrid) => {
        let searchText = "";
        let headerPanelView;
        try {
            headerPanelView = gridInstance["getView"]('headerPanel');
            const searchPanel = headerPanelView.option('searchPanel');
            if (searchPanel) {
                searchText = searchPanel.text || "";
            }
        }
        catch (e) {
            console.error(e);
            return searchText;
        }
        return searchText;
    }
    public static getFilterAndSearchText = async (gridInstance: dxDataGrid) => {
        let filterText = await ExtractorDataGridOptions.getFilterText(gridInstance);
        let searchText = ExtractorDataGridOptions.getSearchText(gridInstance);
        if (searchText) {
            searchText = "Поисковая строка: " + searchText;
        }
        if (filterText || searchText) {
            filterText = "Фильтр:\n"
                + searchText
                + (searchText && filterText ? "\n" : "")
                + filterText;
        }
        return filterText;
    }

    public static getColumns = (gridInstance: dxDataGrid) => {
        let res = [];
        let rr = gridInstance.columnCount();
        for (let i = 0; i < rr; i++) {
            let col = gridInstance.columnOption(i);
            res.push(col);
        }
        return res;
    }
    public static getColumnsOfGrids = (components: Array<IReportOneUIComponent>) => {
        for (let item of components) {
            if (!item) continue;
            if (!item.component) continue;
            if (item.component["NAME"] == "dxDataGrid") {
                let component = item.component as dxDataGrid;
                const layoutGrid = ExtractorDataGridOptions.getColumns(component);
                item["currentColumns"] = layoutGrid;
//                const filterValue = ExtractorDataGridOptions.getFilterValue(component);
//                item["currentFilterValue"] = filterValue;
            }
        }
        return components;
    }   
/*
    public static getFilterValue = (gridInstance: dxDataGrid) => {
        let res = null;
        console.log('gridInstance for getFilterValue ');
        console.log(gridInstance);
        try {
            res = gridInstance["getView"]('columnHeadersView').option('filterValue');
        }
        catch (e) {
            console.error(e);
        }
       return res;
    }
*/

}